var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      attrs: { value: "", "escape-close": "" },
      on: {
        input: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "420" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("add-label")))]),
          _c(
            "w-card-content",
            [
              !_vm.labels.length
                ? _c("div", { staticClass: "empty" }, [
                    _vm._v(_vm._s(_vm.$ct("no-labels"))),
                  ])
                : _vm._e(),
              _vm._l(_vm.labels, function (label) {
                return _c(
                  "a",
                  {
                    key: label.ID,
                    staticClass: "label-row",
                    class: { busy: _vm.saving },
                    on: {
                      click: function ($event) {
                        return _vm.toggle(label)
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "dot",
                      style: { backgroundColor: label.Color },
                    }),
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(label.Name)),
                    ]),
                    _vm.isAssigned(label)
                      ? _c("w-fa", {
                          staticClass: "check",
                          attrs: { icon: "check" },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }